"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _StringUtil = _interopRequireDefault(require("./StringUtil"));

var _eq2 = _interopRequireDefault(require("lodash/eq"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PropertiesUtil = /*#__PURE__*/function () {
  function PropertiesUtil() {
    _classCallCheck(this, PropertiesUtil);
  }

  _createClass(PropertiesUtil, null, [{
    key: "parseObject",
    value: function parseObject(obj) {
      var values = [];

      if (_StringUtil.default.isString(obj)) {
        values.push(obj);
      } else {
        var keys = Object.keys(obj);
        keys.forEach(function (key) {
          var parsedKeys = PropertiesUtil.parseObject(obj[key]);
          parsedKeys.forEach(function (parsedKey) {
            console.log('parsedKey', parsedKey);

            if (parsedKey.includes(' = ')) {
              if (parsedKey.startsWith(' = ')) {
                values.push(key + parsedKey);
              } else {
                values.push(key + '.' + parsedKey);
              }
            } else {
              values.push(key + ' = ' + parsedKey);
            }
          });
        });
      }

      return values;
    }
  }, {
    key: "stringify",
    value: function stringify(obj) {
      var values = PropertiesUtil.parseObject(obj);
      return values.join('\n');
    }
  }, {
    key: "eq",
    value: function eq(source, target) {
      return (0, _eq2.default)(source, target);
    }
  }]);

  return PropertiesUtil;
}();

exports.default = PropertiesUtil;